import 'reflect-metadata';
import {jsonObject, jsonMember} from 'typedjson';

@jsonObject
export class SystemInfo {

  @jsonMember({name: 'serial'})
  public Serial!: string;

  @jsonMember({name: 'dateTime'})
  public DateTime!: Date;

  @jsonMember({name: 'uptime'})
  public Uptime!: number;

  @jsonMember({name: 'temperatureStatus'})
  public TemperatureStatus!: string;
}
